<app-default-layout
  [title]="'Ihr Profil'"
  [subtitle]="'Profil bearbeiten'"
>

  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="frame frame-default">
        <div id="edit-benutzer" class="content scaffold-edit " role="main">
          <form [formGroup]="benutzerForm" (ngSubmit)="this.updateBenutzer()" class="form-horizontal" accept-charset="UTF-8">

            <div class="form-group sfk-form-vertical-spacer group-for-name mb-0 mt-0"
                 *ngIf="isVisible('name')"
            >
              <app-custom-input id="name"
                                type="text"
                                [customFormGroup]="benutzerForm"
                                [label]="getFieldLabelOrTranslate('name','STANDARD.NACHNAME')"
                                [infoTextBelowInput]="isRequired('name')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                                data-cy="profil-name"
              ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-vorname mb-0 mt-0"
                 *ngIf="isVisible('vorname')"
            >
                  <app-custom-input id="vorname"
                                    type="text"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('vorname','STANDARD.VORNAME')"
                                    [infoTextBelowInput]="isRequired('vorname')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                                    data-cy="profil-vorname"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-strasse mb-0 mt-0"
                 *ngIf="isVisible('strasse')"
            >
                  <app-custom-input id="strasse"
                                    type="text"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('strasse','STANDARD.STRASSE')"
                                    [noteText]="'Bitte geben Sie die Straße und die Hausnummer an.'"
                                    [infoTextBelowInput]="isRequired('strasse')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                                    data-cy="profil-strasse"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-adresszusatz mb-0 mt-0"
                 *ngIf="isVisible('adresszusatz')"
            >
                  <app-custom-input id="adresszusatz"
                                    type="text"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('adresszusatz','STANDARD.ADRESSZUSATZ')"
                                    [infoTextBelowInput]="'Hier können Sie Zusatzinformationen zur Anschrift angeben. Beispiel: Zimmernummer.'"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-plz mb-0 mt-0"
                 *ngIf="isVisible('plz')"
            >
                  <app-custom-input id="plz"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('plz','STANDARD.PLZ')"
                                    (onchange)="setOrt($event, 'ort')"
                                    [maxlength]="getMaxPlzLength('land')"
                                    [pattern]="getPlzPattern('land')"
                                    [infoTextBelowInput]="isRequired('plz')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                                    data-cy="profil-plz"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-ort mb-0 mt-0"
                 *ngIf="isVisible('ort')"
            >
                  <app-custom-input id="ort"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('ort','STANDARD.ORT')"
                                    [infoTextBelowInput]="isRequired('ort')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                                    data-cy="profil-ort"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-land mb-0 mt-0"
                 *ngIf="isVisible('land')"
            >
                  <app-custom-select
                    id="land"
                    [class]="'sfk-ellipsed-ng-select'"
                    [customFormGroup]="benutzerForm"
                    [items]="landList"
                    [multiple]="false"
                    [clearable]="false"
                    bindLabel="value"
                    bindValue="name"
                    [label]="getFieldLabelOrTranslate('land','STANDARD.LAND')"
                    [infoTextBelowInput]="isRequired('land')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                  ></app-custom-select>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-geschlecht mb-0 mt-0"
                 *ngIf="isVisible('geschlecht')"
            >
                  <app-custom-select id="geschlecht"
                                     [class]="'sfk-ellipsed-ng-select'"
                                     [customFormGroup]="benutzerForm"
                                     placeholder="-"
                                     [items]="optionGeschlecht"
                                     [multiple]="false"
                                     [clearable]="false"
                                     bindLabel="name"
                                     bindValue="id"
                                     [label]="getFieldLabelOrTranslate('geschlecht','STANDARD.GESCHLECHT.TITEL')"
                                     [infoTextBelowInput]="isRequired('geschlecht')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                  ></app-custom-select>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-geburtsdatum mb-0 mt-0"
                 *ngIf="isVisible('geburtsdatum')"
            >
                  <app-custom-input class="datepicker"
                                    id="geburtsdatum"
                                    [type]="'date'"
                                    [customFormGroup]="benutzerForm"
                                    data-content="dd.mm.yyyy"
                                    [max]="this.maxDate | date:'yyyy-MM-dd'"
                                    [min]="this.minDateBirthday | date:'yyyy-MM-dd'"
                                    [label]="getFieldLabelOrTranslate('geburtsdatum','STANDARD.GEBURTSDATUM')"
                                    [infoTextBelowInput]="(isRequired('geburtsdatum')?translateService.instant('PROFIL.FORM.REQUIRED'):'')
                                      + ' ' + getTextbausteinOrTranslate(KeyString.GEBURTSDATUM_INFO_BELOW,'')"
                                    data-cy="profil-geburtsdatum"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-telefonnummer mb-0 mt-0"
                 *ngIf="isVisible('telefonnummer')"
            >
                  <app-custom-input id="telefonnummer"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('telefonnummer','STANDARD.TELEFONNUMMER')"
                                    [infoTextBelowInput]="isRequired('telefonnummer')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-abonnementnummer mb-0 mt-0"
                 *ngIf="isVisible('abonnementnummer')"
            >
                  <app-custom-input id="abonnementnummer"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('abonnementnummer','STANDARD.ABONNEMENTNUMMER')"
                                    [infoTextBelowInput]="isRequired('abonnementnummer')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                  ></app-custom-input>
            </div>

            <div class="form-group sfk-form-vertical-spacer group-for-email mb-0 mt-0"
                 *ngIf="isVisible('email')"
            >
                  <app-custom-input id="email"
                                    [customFormGroup]="benutzerForm"
                                    [label]="getFieldLabelOrTranslate('email','STANDARD.EMAIL')"
                                    [infoTextBelowInput]="isRequired('email')?translateService.instant('PROFIL.FORM.REQUIRED'):''"
                                    data-cy="profil-email"
                  ></app-custom-input>
            </div>

            <div class="row justify-content-between">
              <div class="col-3">
                <button type="submit" class="btn btn-primary save" data-cy="profil-savebtn">
                  <fa-icon [icon]="faSave"></fa-icon>
                  {{'APPLICATION.BUTTON_PROFIL_SPEICHERN' |translate }}
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner
    [color]="'var(--spinner-color)'"
    [bdColor]="'var(--spinner-bd-color)'"
    size="medium"
    type="ball-scale-multiple"
    [fullScreen] = "true"
  >
  </ngx-spinner>
</app-default-layout>
